import React from 'react';

const ActivePlayer = (props) => {
  return (
    <h2>You are {props.player}</h2>
  )
};

export default ActivePlayer;